module.exports = __webpack_public_path__ + "img/Gewuerze_1.aa9bd578.jpeg";